// Mock data for copywriting portfolio

export const mockData = {
  hero: {
    tagline: "Writing good copy is not enough until you have the right strategy. Period.",
    subtitle: "I build revenue-focused flows + campaigns",
    results: "Conversion gains up to 25% through sharp copy and clean strategy",
    backgroundImage: "https://images.unsplash.com/photo-1509483730228-811e47696246",
    ctaText: "Let's Talk Strategy"
  },
  
  about: {
    name: "Email Strategist & Copywriter",
    image: "https://customer-assets.emergentagent.com/job_copy-converter-1/artifacts/vgk605ln_ig%20image.jpg",
    description: "I don't just write emails—I engineer revenue systems. Every word, every sequence, every campaign is built to convert browsers into buyers and one-time customers into repeat revenue."
  },
  
  services: [
    {
      id: 1,
      title: "Welcome Flows",
      description: "Turn new subscribers into customers with strategic automation that builds trust and drives action from day one.",
      results: "Average 15-20% conversion rate"
    },
    {
      id: 2,
      title: "Campaign Strategy",
      description: "Revenue-generating email campaigns that cut through inbox noise with sharp copy and conversion-focused messaging.",
      results: "Boost campaign revenue by 25%+"
    },
    {
      id: 3,
      title: "Abandoned Cart Recovery",
      description: "Reclaim lost revenue with persuasive sequences that bring customers back to complete their purchase.",
      results: "Recover 10-15% of lost sales"
    },
    {
      id: 4,
      title: "Post-Purchase Flows",
      description: "Maximize customer lifetime value with retention sequences that turn buyers into brand advocates.",
      results: "Increase repeat purchase rate"
    }
  ],
  
  stats: [
    {
      id: 1,
      number: "25%",
      label: "Average Revenue Increase",
      description: "For ecommerce clients through email optimization"
    },
    {
      id: 2,
      number: "98%",
      label: "Client Satisfaction",
      description: "Clients see measurable results within 60 days"
    },
    {
      id: 3,
      number: "50+",
      label: "Flows Created",
      description: "High-converting email sequences deployed"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      quote: "The email strategy completely transformed our revenue model. We went from sporadic sales to consistent daily conversions.",
      author: "Sarah Mitchell",
      company: "Luxe Beauty Co.",
      result: "+32% email revenue in 90 days"
    },
    {
      id: 2,
      quote: "Finally, someone who understands that email isn't just about 'engaging content'—it's about driving sales. The ROI speaks for itself.",
      author: "Marcus Chen",
      company: "Urban Threads Apparel",
      result: "+30% Click Through Rate"
    },
    {
      id: 3,
      quote: "The abandoned cart sequences alone paid for the investment 3x over. Sharp copy that actually converts.",
      author: "Jennifer Brooks",
      company: "Home & Hearth Decor",
      result: "15% cart recovery rate"
    }
  ],
  
  contact: {
    email: "nitinpathakhere@gmail.com",
    socialLinks: [
      { platform: "LinkedIn", url: "https://www.linkedin.com/in/nitinpathakk/" },
      { platform: "Instagram", url: "https://www.instagram.com/nitinpathakk/" },
      { platform: "Twitter", url: "https://x.com/NitinPathakk" }
    ]
  }
};